<form name="frmAccount" id="frmAccount" #frmAccount="ngForm">
    <div class="card">
        <div class="card-header">
            <label class="control-label" paflabel="Informations_comptables"></label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-2">
                    <div style="width:180px;">
                        <label class="control-label" paflabel="Devise_de_commande"></label>
                        <paf-combobox name="orderCurrency" [(ngModel)]="supplier.OrderCurrency"
                            [data]="sharedDatasSvc.currencies" [disabled]="infoComptableOthersDisabled  || !isEditing()"
                            [required]="true"></paf-combobox>
                    </div>
                </div>
                <div class="col-3 d-flex mt-2" *ngIf="sharedDatasSvc.portalType=='INTRANET'">
                    <label class="control-label mt-3 text-right" paflabel="Langue_utilisee_avec_le_fournisseur"></label>
                    <div class="d-flex flex-column align-items-center mr-2">
                        <img class="lng-btn mb-1" [src]="frBtnImagePath">
                        <input id="optFR" type="radio" value="FR" name="LngCodFr" [(ngModel)]="supplier.LngCod"
                            [disabled]="infoComptableOthersDisabled  || !isEditing()">
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <img class="lng-btn mb-1" [src]="enBtnImagePath">
                        <input id="optEN" type="radio" value="EN" name="LngCodEn" [(ngModel)]="supplier.LngCod"
                            [disabled]="infoComptableOthersDisabled  || !isEditing()">
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <switchery-ios [(ngModel)]="TopAffacturage" size="small" name="TopAffacturage"
                        [label]="lblTopAffacturage | async" [disabled]="infoComptableOthersDisabled || !isEditing()">
                    </switchery-ios>
                </div>
            </div>
            <div *ngIf="TopAffacturage">
                <div class="row">
                    <div class="col-4">
                        <label class="control-label" paflabel="Nom_de_la_societe_d_affacturage"></label>
                        <input type="text" name="AffacturageName" class="form-control"
                            [(ngModel)]="supplier.AffacturageName" required
                            [disabled]="infoComptableOthersDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="AffacturageName"></validation-errors>
                    </div>
                    <div class="col-2">
                        <label class="control-label" paflabel="Num_siren_ou_num_siret"></label>
                        <input type="text" name="AffacturageSiret" onlyNumbers mask="00000000099999"
                            class="form-control" [(ngModel)]="supplier.AffacturageSiret" required
                            [disabled]="infoComptableOthersDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="AffacturageSiret"></validation-errors>
                    </div>
                    <div class="col-2">
                        <label class="control-label" paflabel="Telephone"></label>
                        <input type="text" name="AffacturagePhone" class="form-control"
                            [(ngModel)]="supplier.AffacturagePhone"
                            [disabled]="infoComptableOthersDisabled || !isEditing()">
                    </div>
                    <div class="col-2">
                        <label class="control-label" paflabel="Nom_du_contact"></label>
                        <input type="text" name="AffacturageContactName" class="form-control"
                            [(ngModel)]="supplier.AffacturageContactName"
                            [disabled]="infoComptableOthersDisabled || !isEditing()">
                    </div>
                    <div class="col-2">
                        <label class="control-label" paflabel="Email"></label>
                        <input type="email" name="AffacturageEmail" class="form-control"
                            [(ngModel)]="supplier.AffacturageEmail"
                            [disabled]="infoComptableOthersDisabled || !isEditing()">
                    </div>
                </div>
                <div class="row">
                    <div class="col" paflabel="Votre_RIB_doit_correspondre_a_celui_de_la_societe_d_affacturage"></div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <switchery-ios [(ngModel)]="TopAddrFac" size="small" name="TopAddrFac"
                        [label]="lblTopAddrFac | async" [disabled]="infoComptableOthersDisabled || !isEditing()">
                    </switchery-ios>
                </div>
                <div class="flex-grow-1">
                    <div *ngIf="TopAddrFac && supplier.FacAddress" class="card px-2 pb-1">
                        <div class="d-flex flex-column align-items-start">
                            <label class="control-label" paflabel="Adresse"></label>

                            <div class="d-flex" style="width:100%;">
                                <input type="text" class="form-control" name="FacAddrNum"
                                    [(ngModel)]="supplier.FacAddress.AddrNum" style="width:60px;"
                                    [disabled]="infoComptableOthersDisabled || !isEditing()">
                                <div class="flex-grow-1 ml-1">
                                    <input type="text" class="form-control" name="FacAddr1"
                                        [(ngModel)]="supplier.FacAddress.Addr1" style="width:100%;" required
                                        [disabled]="infoComptableOthersDisabled || !isEditing()">
                                    <validation-errors [form]="frmAccount" controlName="FacAddr1"></validation-errors>
                                </div>
                            </div>
                            <input type="text" class="form-control mt-1" name="FacAddr2"
                                [(ngModel)]="supplier.FacAddress.Addr2" style="width:100%;"
                                [disabled]="infoComptableOthersDisabled || !isEditing()">
                            <div class="d-flex mt-1" style="width:100%;">
                                <label class="control-label ml-1" paflabel="Code_postal"></label>
                                <div style="width:150px;">
                                    <input type="text" class="form-control" name="FacPostalCod" maxlength="16"
                                        [(ngModel)]="supplier.FacAddress.PostalCod" style="width:100%;" required
                                        [disabled]="infoComptableOthersDisabled || !isEditing()">
                                    <validation-errors [form]="frmAccount"
                                        controlName="FacPostalCod"></validation-errors>
                                </div>

                                <label class="control-label ml-1" paflabel="Ville"></label>
                                <div class="flex-grow-1">
                                    <input type="text" class="form-control" name="FacCity"
                                        [(ngModel)]="supplier.FacAddress.City" required style="width:100%"
                                        [disabled]="infoComptableOthersDisabled || !isEditing()">
                                    <validation-errors [form]="frmAccount" controlName="FacCity"></validation-errors>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col-auto  mt-2">
                    <switchery-ios [(ngModel)]="supplier.TopRFE" size="small" name="TopRFE" [label]="lblTopRfe | async"
                        [disabled]="infoComptableDematDisabled || !isEditing()">
                    </switchery-ios>
                </div>
            </div>
            <div *ngIf="supplier.TopRFE == true">
                <div class="row mt-1">
                    <div class="col">
                        <label class="control-label" paflabel="Fournisseurs_soumis_a_la_RFE_Msg">
                        </label>
                        <span [title]="Label('Fournisseurs_soumis_a_la_RFE') | async" data-toggle="tooltip"
                            data-placement="top">
                            <a class="btn btn-sm btn-info ml-1 fa fa-info" href="javascript:void(0);"
                                (click)="docsSvc.DownloadAndSavePafDoc('RFE_FACT_ELECTRONIQUE', supplier.Id)">
                            </a>
                        </span>
                    </div>
                </div>
                <div class="row mt-1" *ngIf="showRFEFields">
                    <div class="col-4">
                        <label class="control-label" paflabel="Adresse_de_routage"></label>
                        <input type="string" name="RoutageEmail" [(ngModel)]="supplier.RoutageEmail"
                            class="form-control" [disabled]="infoComptableDematDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="RoutageEmail"></validation-errors>
                    </div>
                    <div class="col-4">
                        <label class="control-label" paflabel="Code_de_routage"></label>
                        <input type="text" name="RoutageCod" [(ngModel)]="supplier.RoutageCod" class="form-control"
                            maxlength="255" [disabled]="infoComptableDematDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="RoutageCod"></validation-errors>
                    </div>
                </div>
            </div>
            <div *ngIf="supplier.TopRFE != true">
                <div class="row mt-1">
                    <div class="col">
                        <label class="control-label" paflabel="Non_RFE_Alert_Msg">
                        </label>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col">
                        <label class="control-label" paflabel="Fournisseurs_non_soumis_a_la_RFE">
                        </label>
                        <label class="ms-1" class="control-label" paflabel="Voir_conditions_a_respecter_ci_dessous">
                        </label>
                    </div>
                </div>

                <div class="d-flex flex-row justify-content-start align-items-center mt-1">
                    <!-- <div class="col-auto mr-1 mt-2">
                        <button type="button" class="btn btn-sm btn-info fa fa-info-circle"
                            (click)="showHideinfoDematWindow(true)" paftooltip="Info_Demat_Title"></button>
                    </div>

                     -->
                    <switchery-ios [(ngModel)]="TopFacDemat" size="small" name="TopFacDemat"
                        [label]="lblTopFacDemat | async" [disabled]="infoComptableDematDisabled || !isEditing()">
                    </switchery-ios>
                    <!-- <div class="mx-1">
                        <button type="button" class="btn btn-sm btn-info fa fa-info"
                            (click)="showHideinfoDematWindow(true)" paftooltip="Info_Demat_Title"></button>
                        <kendo-window #windowInfoDemat *ngIf="infoDematWindowSettings.visible"
                            [minWidth]="infoDematWindowSettings.minWidth"
                            [minHeight]="infoDematWindowSettings.minHeight"
                            [resizable]="infoDematWindowSettings.resizable" (close)="showHideinfoDematWindow(false)"
                            [title]="Label('Info_Demat_Title') | async">
                            <kendo-window-titlebar>
                                <div class="k-window-title">
                                    <paflabel lblCod="Info_Demat_Title"></paflabel>
                                </div>
                                <button kendoWindowCloseAction></button>
                            </kendo-window-titlebar>
                            <infos-demat (closeWindow)="showHideinfoDematWindow(false)"></infos-demat>
                        </kendo-window>
                    </div> -->

                    <a class="ms-1" href="javascript:void(0);" (click)="btnDownloadConditionsFile()"
                        paflabel="CONDITIONS_A_RESPECTER_LORS_DE_TOUT_ENVOI_DE_DOCUMENTS">
                    </a>
                </div>
                <div class="row mt-1" *ngIf="TopFacDemat">
                    <div class="col-4">
                        <label class="control-label" style="height:40px;"
                            paflabel="Adresse_mail_pour_l_envoi_des_factures"></label>
                        <input type="email" name="FacSendEmail" [(ngModel)]="supplier.FacSendEmail" class="form-control"
                            email="true" required [disabled]="infoComptableDematDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="FacSendEmail"></validation-errors>
                    </div>
                    <div class="col-4">
                        <label class="control-label" style="height:40px;"
                            paflabel="Addresse_mail_pour_le_retour_des_factures"></label>
                        <input type="email" name="FacReturnEmail" [(ngModel)]="supplier.FacReturnEmail"
                            class="form-control" email="true" required
                            [disabled]="infoComptableDematDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="FacReturnEmail"></validation-errors>
                    </div>
                    <div class="col-4">
                        <label class="control-label" style="height:40px;"
                            paflabel="Adresse_mail_envoi_d_avis_de_virement"></label>
                        <input type="email" name="PaySendEmail" [(ngModel)]="supplier.PaySendEmail" class="form-control"
                            email="true" required [disabled]="infoComptableDematDisabled || !isEditing()">
                        <validation-errors [form]="frmAccount" controlName="PaySendEmail"></validation-errors>
                    </div>
                </div>
                <div class="row" *ngIf="TopFacDemat">
                    <div class="col-auto mt-3">
                        <label class="control-label" paflabel="Msg_Alerte_Email_Demat"></label>
                    </div>
                </div>

            </div>
        </div>
    </div>


</form>